import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import axios from 'axios';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

const root = createRoot(document.getElementById('root')!);

axios.get('/api/config/authentication')
  .then((response) => {
    const msalConfig = response.data.msal;
    const msalInstance = new PublicClientApplication(msalConfig);

    msalInstance.handleRedirectPromise()
      .then((redirectResponse) => {
        if (redirectResponse) {
          console.log('Redirect login successful');
        }

        root.render(
          <React.StrictMode>
            <Provider store={store}>
              <MsalProvider instance={msalInstance}>
                <ThemeProvider theme={theme}>
                  <BrowserRouter>
                    <App />
                  </BrowserRouter>
                </ThemeProvider>
              </MsalProvider>
            </Provider>
          </React.StrictMode>
        );
      })
      .catch((error) => {
        console.error('Error handling redirect: ', error);
        root.render(
          <div>Error during authentication. Please contact support.</div>
        );
      });
  })
  .catch(() => {
    root.render(
      <div>Error loading page. Please contact support.</div>
    );
  });